import { SIMULATION_INSURANCE_TYPE } from '@/constants/simulation.const';
import {
	CalculateSimulationRequest,
	GetSimulationDetailResponse,
} from '@/libs/fleet-api/services/simulation';
import { Col, DatePicker, Divider, Form, Row } from 'antd';
import { NamePath } from 'antd/es/form/interface';

type SimInsuranceBankerClauseProps = {
	renderUploadField: (
		name: string,
		label: string,
		initialValue: string | undefined,
		isViewOnly?: boolean,
	) => JSX.Element;
	simulationDetailData: GetSimulationDetailResponse;
	insuranceOrder?: number;
	fieldName: (name: NamePath<CalculateSimulationRequest>) => typeof name;
	viewOnly?: boolean;
};

const SimInsuranceBankerClause: React.FC<SimInsuranceBankerClauseProps> = ({
	renderUploadField,
	simulationDetailData,
	insuranceOrder,
	fieldName,
	viewOnly = false,
}) => {
	return (
		<>
			<Row gutter={40}>
				<Col span={12}>
					<Form.Item label={`Tipe Asuransi ${insuranceOrder ?? ''}`}>
						{insuranceOrder
							? insuranceOrder === 1
								? simulationDetailData.firstInsuranceType
								: simulationDetailData.secondInsuranceType
							: simulationDetailData.insuranceType}
					</Form.Item>
				</Col>
				{simulationDetailData.insuranceType ===
					SIMULATION_INSURANCE_TYPE.COMBINATION ||
				simulationDetailData.insuranceType ===
					SIMULATION_INSURANCE_TYPE.REKANAN ? (
					<>
						<Col
							span={12}
							style={{ display: 'flex', gap: 4 }}
						>
							<Form.Item
								label={`Asuransi Tenor ${insuranceOrder}`}
								name={fieldName('bankerClauseStartDate')}
								rules={[{ required: true }]}
							>
								<DatePicker
									style={{ borderRadius: 8 }}
									format="DD-MM-YYYY"
								/>
							</Form.Item>
							<Form.Item name={fieldName('bankerClauseEndDate')}>
								<DatePicker
									style={{ borderRadius: 8 }}
									format="DD-MM-YYYY"
								/>
							</Form.Item>
						</Col>
					</>
				) : null}
			</Row>
			<Divider />

			<Row gutter={16}>
				<Col span={12}>
					{renderUploadField(
						'insurancePolicyDocument',
						'Upload Dokumen Polis Asuransi',
						simulationDetailData?.insurancePolicyDocument?.id?.toString(),
						viewOnly,
					)}
				</Col>
				<Col span={12}>
					{renderUploadField(
						'insurancePaymentDocument',
						'Upload Bukti Pembayaran Asuransi',
						simulationDetailData?.insurancePaymentDocument?.id?.toString(),
						viewOnly,
					)}
				</Col>
			</Row>
		</>
	);
};

export default SimInsuranceBankerClause;
